/* tslint:disable */
require('./AttachmentsRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_fd2a9d07',
  relative: 'relative_fd2a9d07',
  container: 'container_fd2a9d07',
  fabricIcon: 'fabricIcon_fd2a9d07',
};

export default styles;
/* tslint:enable */